module.exports = __webpack_public_path__ + "static/img/sunwoospring-csr.542140a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/sunwoospring-csr.jpg
// module id = H1oT
// module chunks = 0